<template>
  <div class="WorkDetail">
    <div class="flex">
      <img
        @click="$emit('close')"
        class="close"
        src="@/assets/img/close.png"
        alt=""
      />
    </div>
    <div class="main">
      <div class="head flex">
        <span class="head_title">生成名片</span>
        <div class="download_btn">打包下载</div>
      </div>
      <div class="main_content flex">
        <div class="content_left column">
          <div class="content_left_title">选择模板</div>
          <div class="template_list">
            <div
              class="template_item"
              :class="{ active_template_item: index == activeTemplateIndex }"
              v-for="(item, index) in 7"
              :key="index"
              @click="activeTemplateIndex = index"
            ></div>
          </div>
        </div>
        <div class="content_middle"></div>
        <div class="content_right">
          <div class="title">选择团队成员</div>
          <div class="column">
            <div
              class="member_item flex"
              v-for="(item, index) in 7"
              :key="index"
            >
              <input
                type="checkbox"
                :id="'check' + index"
                v-model="isChecked"
              /><label :for="'check' + index">姓名</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  components: {},
  data() {
    return {
      activeTemplateIndex: 0,
      isChecked: false,
    };
  },
  methods: {},
};
</script>
            
  <style lang="scss" scoped>
.WorkDetail {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .close {
    width: 24px;
    height: 24px;
    margin: 12px 24px 12px auto;
    cursor: pointer;
  }
  .main {
    height: 100%;
    background: #ffffff;
    border-radius: 24px 24px 0px 0px;

    .head {
      height: 80px;
      border-bottom: 1px solid #eeeeee;
      padding: 0 32px;
      .head_title {
        font-weight: 600;
        font-size: 24px;
        color: #242424;
        margin-right: 20px;
      }

      .download_btn {
        width: 80px;
        height: 32px;
        background: #242424;
        border-radius: 100px;
        text-align: center;
        line-height: 32px;
        font-size: 12px;
        color: #f3f3f3;
        margin-left: auto;
        cursor: pointer;
      }
    }
    .main_content {
      height: 100%;
      .content_left {
        width: 360px;
        height: 100%;
        background: #ffffff;
        border-right: 1px solid #eeeeee;
        padding: 0 24px;

        .content_left_title {
          height: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #242424;
          line-height: 24px;
          margin: 24px 0;
        }
        .template_list {
          height: calc(100% - 220px);
          overflow: auto;
          /* 隐藏默认的滚动条样式 */
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE and Edge */

          .template_item {
            width: 308px;
            height: 189px;
            background: #ffffff;
            box-shadow: 0px 3px 24px 0px rgba(151, 151, 151, 0.08);
            border-radius: 4px;
            border: 1px solid #e0e0e0;
            margin-bottom: 20px;
            cursor: pointer;
            &:hover {
              border: 2px solid #9bdb4a;
            }
          }
        }
      }
      .content_middle {
        height: 100%;
        flex-grow: 1;
        background: #f9f9f9;
      }
      .content_right {
        width: 160px;
        height: 100%;
        background: #ffffff;
        border-left: 1px solid #eeeeee;
        padding: 24px;
        .title {
          height: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #242424;
          line-height: 24px;
          margin-bottom: 24px;
        }
        .member_item {
          margin-bottom: 7px;
          label {
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            margin-left: 4px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
            